


























import Vue from 'vue';

import apiFetch from '../lib/api';

import Title from './Title.vue';

type Ranking = {
  name: string;
  surname: string;
  points: number;
  duration: number;
};

type RankingResponse = {
  ranking: Ranking[];
};

type Data = {
  loading: boolean;
  ranking: Ranking[];
};

export default Vue.extend({
  name: 'Faq',
  components: {
    Title,
  },
  data(): Data {
    return {
      loading: true,
      ranking: [],
    };
  },
  async activated(): Promise<boolean> {
    try {
      const data: RankingResponse = await apiFetch('ranking');

      this.ranking = data.ranking.map((item: Ranking) => {
        const cleaned = {
          ...item,
          name: this.decodeString(item.name),
          surname: this.decodeString(item.surname),
          duration: Math.round(item.duration / 1000),
        };

        return cleaned;
      });
      this.loading = false;

      return true;
    } catch (response) {
      throw new Error(response);
    }
  },
  methods: {
    decodeString(string: string) {
      return decodeURIComponent(string).replace(/</g, '&lt;').replace(/>/g, '&gt;');
    },
  },
});
